<template>
    <v-container class="py-0">
        <v-row v-if="optionsListLoading">
            <v-col cols="12" ></v-col>
        </v-row>
        <v-row class="pb-4" v-else>
            <v-col cols="6" v-for="(item, index) in optionsList" :key="index" class="py-0 my-0">
              <v-switch v-model="optionsLocal[item.id]" @change="setOption(item.id)" :disabled="optionsOff" inset :label="taxLabel(item)" color="success" hide-details class="mt-1" v-if="item"></v-switch>
              <span v-if="optionsLocal[item.id]&&item.is_numerable">
                <v-btn @click="minusQ(item)" x-small fab depressed><v-icon>mdi-minus</v-icon></v-btn>
                {{ optionsQ[item.id] }}
                <v-btn @click="plusQ(item)" x-small fab depressed><v-icon>mdi-plus</v-icon></v-btn>
              </span>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        name: 'chooseOptions',
        props: ['side', 'paintType'],
        computed: {
            optionsQ () {
                return this.$store.state[this.source].wheels[this.side].data.optionsQ
            },
            optionsList () {
              const optionsList = Object.values(this.$store.state.paint.options)
              console.log('optlist', optionsList)
              return optionsList.filter(x => x.type === this.paintType + 1)
            },
            optionsListLoading () {
                return this.$store.state.paint.optionsListLoading
            },
            optionsOff(){
              return this.paintType === 4
            },
            twoColors: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.twoColors
                },
                set(value) {
                    this.$store.commit(this.source+'/setPlus', { side: this.side, value , item:'twoColors'})
                }
            },
        },
        data () {
            return {
                optionsLocal: {},
                source: 'paint'
            }
        },
        mounted () {
            this.optionsLocal =  JSON.parse(JSON.stringify(this.$store.state.paint.wheels[this.side].data.options))
        },
        watch: {
            paintType () {
              for (let y in this.optionsLocal){
                this.optionsLocal[y] = false
              }
              this.$store.commit(this.source+'/setPlusToZero')
            }
        },
        methods:{
            minusQ(item) {
                let newval = this.optionsQ[item.id]
                if (newval>=2) newval = this.optionsQ[item.id] - 1
                this.$store.commit(this.source+'/changeQuantity', { side: this.side, id:item.id, value: newval})
            },
            plusQ(item) {
                let newval = this.optionsQ[item.id] + 1
                this.$store.commit(this.source+'/changeQuantity', { side: this.side, id:item.id, value: newval})
            },
            taxLabel (val){
                let radius = this.$store.state.paint.wheels[this.side].data.radius
                let label = val.name
                let summ =  val.summ
                if (val.multi>100){
                    const tempmult = val.multi - 100
                    label = label + ' (+' + tempmult + '%)'
                }else if (val.summ>0) {
                    if (val.is_numerable) summ = summ * this.optionsQ[val.id]
                    label = label + ' (+' + summ + '₽)'

                } else if (val.options.length > 0) {
                    summ = val.options.find(v => v.radius == radius ||radius >= v.r_min && radius <= v.r_max ).price
                    label = label + ' (+' + summ + '₽)'
                }
                return label

            },
            setOption (valID) {
                //console.log(valID)
                this.$store.commit('paint/updateOptions', { side: this.side, id:valID, value:this.optionsLocal[valID] })
            }
        },
    }
</script>
<style lang="scss">
    .addpricetext {
        color: forestgreen;
        font-weight: bold;
        padding-left: 15px;
    }
    .border {
        border-radius: 4px;
        border: thin solid rgba(0,0,0,.12);
    }
    .primary_bg_color {
        background-color: #FFFEEE !important;
    }
    .primary_bg_color .active {
        background-color: #FFFBCD !important;
    }
    .change_disk.v-btn-toggle .v-btn{
        height: 51px !important;
        width: 80px !important;
    }
    .change_disk.v-btn-toggle{
        height: 51px !important;
        width: 80px !important;
    }
    .tabs_icons_big {
        width: 40px;
        height: 40px;
    }
</style>
